import { makeObservable, observable, computed, action } from 'mobx';
import { apiHost, erpApiurl } from './APIEndpoints';
import { authenticationQuery, registrationQuery, resetPasswordQuery } from './Queries';

const INIT = "init";
const PENDING = 'pending';
const INVALID = 'invalid';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const REGISTRATION_ERROR = { status: "error", help: "We are unable to register you at this moment. Please write to us." };
const PASSWORD_RESET_ERROR = { status: "error", help: "We are unable to reset your password. Please write to us." };
export default class LoginStore {

    state = INIT;
    message = EMPTY_MESSAGE;
    knownMembers = {}

    constructor(props) {
        this.apiProxy = props.apiProxy

        makeObservable(this, {
            state: observable,
            message: observable,

            isLoading: computed,
            isDone: computed,
            isError: computed,

            authenticate: action,
            registerUser: action,
            resetPassword: action,
            showOtpPopup: action,
            originalAuthenticate: action
        })

        this.buildKnownMembers();
    }

    buildKnownMembers = () => {
        this.knownMembers["head@numedlabs.com"] = { email: "head@numedlabs.com", password: "qxn#$pmb", id: "1", userType: "member", name: "Accountant" };
        this.knownMembers["sprasanthcse05@gmail.com"] = { email: "sprasanthcse05@gmail.com", password: "qxn#$pmb", id: "2", userType: "head", name: "Chief" };
    }

    get isLoading() {
        return this.state === PENDING;
    }

    get isDone() {
        return this.state === DONE;
    }

    get isError() {
        return this.state === ERROR;
    }

    authenticate = async (values) => {

        let data = this.knownMembers[values.email];

        if (data === undefined) {
            return { state: INVALID, data: null };
        }

        if (data.password !== values.password) {
            return { state: INVALID, data: null };
        }

        return { state: DONE, data: data };
    }

    originalAuthenticate = async (values) => {
        
        const body = {

            userName: values.email,
            userPwd: values.password,
            role: values.role,
        };

        try {
            const response = await this.apiProxy.asyncPost(erpApiurl + "api/auth/GenerateOtp", body);
            const result = await response.json();

            if (result.Message == "OTP sent successfully") {
                return { state: DONE, data: result };
            }

            this.otpRequired = true;
            return { state: INVALID, data: result.Message };
        }
        catch (e) {
            return { state: ERROR, data: null };
        }
    }
    originalAuthenticateWithOTP = async (values) => {
   
        const body = {
            UserName: values.email,
            Password: values.password,
            role: values.role,
            otp: values.otp,
            grant_type:"password"
        };

        try {
            const response = await this.apiProxy.generateToken(erpApiurl + "token", body);
            const result = await response.json();
            if (result.token_type == "bearer") {
                return { state: DONE, data: result.UserDetails };
            }

            this.otpRequired = true;
            return { state: INVALID, data: result.Message };
        }
        catch (e) {
            return { state: ERROR, data: null };
        }
    }

    registerUser = async (request) => {
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const variables = {
            input: {
                fullName: request.fullName,
                email: request.email,
                password: request.password
            }
        };

        try {
            const response = await this.apiProxy.mutate(apiHost, registrationQuery, variables);
            const data = await response.json();

            const result = data.data.createUser;

            if (result.errors && result.errors.length > 0) {
                const reason = result.errors[0].message;

                this.state = ERROR;
                this.message = { status: "error", help: reason };

                return;
            }
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = REGISTRATION_ERROR;
        }
    }

    showOtpPopup = (isVisible) => {
        this.otpRequired = isVisible;
    };

    resetPassword = async (request) => {
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const variables = {
            input: {
                email: request.email,
                password: request.currentPassword,
                newPassword: request.newPassword
            }
        };

        try {
            const response = await this.apiProxy.mutate(apiHost, resetPasswordQuery, variables);
            const data = await response.json();

            const result = data.data.resetPassword;

            if (result.errors && result.errors.length > 0) {
                const reason = result.errors[0].message;

                this.state = ERROR;
                this.message = { status: "error", help: reason };

                return;
            }

            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = PASSWORD_RESET_ERROR;
        }
    }
}
